import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MaintenanceService, MaintenanceStatusDTO} from '../../services/maintenance.service';

@Component({
  selector: 'app-wartung',
  templateUrl: './wartung.component.html',
  styleUrl: './wartung.component.scss',
  imports: [TranslatePipe, DatePipe],
  standalone: true,
})
export class WartungComponent implements OnInit {
  status: MaintenanceStatusDTO | null = null;
  private destroyRef = inject(DestroyRef);

  constructor(
    private maintenanceService: MaintenanceService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.maintenanceService.status$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(status => {
      this.status = status;
      if (status !== null && !status.maintenanceRunning) {
        this.router.navigate(['/home']);
      }
    });
  }
}
